module.exports = "/_next/static/images/CustomerStoryDominos-32a025d5247bc003de63fdd38f6e0514.png";